import { CongestionStatus } from '@/types/api';

type P = {
  isSelected: boolean;
} & CongestionStatus;

const CongestionCard = ({
  title,
  contentColor,
  backgroundColor,
  isSelected,
}: P) => {
  return (
    <div
      style={{
        flex: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: isSelected ? contentColor : '#D4D7DB',
        backgroundColor: isSelected ? backgroundColor : '',
        fontWeight: isSelected ? '700' : '400',
        borderRadius: '4px',
        padding: '8px 12px',
        fontSize: '14px',
        height: '36px',
      }}
    >
      {title}
    </div>
  );
};

export default CongestionCard;
